import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'semantic-ui-react';
import styles from './App.scss';

export default class MobileHeader extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    viewer: PropTypes.object,
    router: PropTypes.object
  };

  render() {
    return (
      <Grid className={styles.mobileHeader}>
        <Grid.Row>
          <Grid.Column only='tablet mobile'>
            <div className='ui top fixed huge menu borderless topNavMobile'>
              {this.props.children}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/App/MobileHeader.js